import { Component, Input, TemplateRef } from '@angular/core';

import * as Services from '@shared/core/services';

@Component({
    selector: 'shared-info-box',
    templateUrl: './info-box.shared.component.html',
    styleUrls: ['./info-box.shared.component.scss']
})
export class InfoBoxComponent {
    @Input() public homeLink: boolean = false;
    @Input() public src: string;
    @Input() public description: string;
    @Input() public homeLinkTitle: string = 'Return to home';

    @Input() public icon: string = 'close';
    @Input() public size: OLO.Components.INDICATOR_SIZE = 'xxlg';
    @Input() public feel: OLO.Components.INDICATOR_FEEL = 'negative-full';
    @Input() public inverted: boolean = false;

    @Input() public loading: boolean = false;
    @Input() public type: OLO.Components.HEADER_TYPE = '3';
    @Input() public left: TemplateRef<any>;
    @Input() public right: TemplateRef<any>;
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = null;
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public paddingTop: OLO.Components.MARGIN_SIZE = null;
    @Input() public paddingBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public brandAccent: boolean = false;
    @Input() public postContent: string | number;
    @Input() public preContent: string | number;
    @Input() public ellipsis: boolean = false;
    //@Input() public center: boolean = false;
    @Input() public counter: number = null;
    @Input() public lineHeight: boolean | string;

    constructor(
        public routeService: Services.RouteService,
    ) { }

    public handleLinkClick($event: Event): Promise<boolean> {
        return this.routeService.navigateToHomeView();
    }

    public get centerHeader(): boolean {
        return window.innerWidth < 768;
    }
}
